
export const LanguageExplanations =
{
    header: <div>
        <p>
            All the languages you know, and all that you want to know. They must be added here to use in a book.
        </p>
        <p className='ernots_Warning'>
            If you delete a language, the corresponding translations will disappear from any books that use it, as will its abbreviations. You'll have to make them again.
        </p>
    </div>,
    publicObject: "A language added by the administrator. You can't delete or edit it, but if you don't need it, it won't really affect your ability to use this site.",
    googleTranslateCode: `Go to Google Translate, choose the language, and type something. Now look at the URL. In the text following the question mark, you'll see strings like "sl=en" and "tl=en". "sl" is the source language, "tl" is the target language, and the two-letter code after that is what you need to put here. Used to create translations and to speak the sentences.`
};